import { useSrpContext } from '@/src/contexts'
import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

export default function Faq() {
    const {
        SEOSrpData: { pageData, searchQuery }
    } = useSrpContext()
    const { origin, destination } = searchQuery || {}
    const { faq } = pageData || {}
    const t = useTranslations('common')
    return (
        <Box component="section" aria-label={t('faqAboutFlights', { origin: origin || '', destination: destination || '' })}>
            <Typography
                component="h2"
                textTransform={'capitalize'}
                fontSize={18}
                fontWeight={600}
                mt={2}
                lineHeight={'27px'}
                color={'#4d4d4d'}
            >
                {t('faqAboutFlights', { origin: origin || '', destination: destination || '' })}
            </Typography>

            <List>
                {faq?.map((item, index) => (
                    <ListItem alignItems="flex-start" key={index} sx={{ py: 0 }}>
                        <ListItemText
                            primary={
                                <Typography component="p" sx={{ fontSize: 15, lineHeight: '27px', p: 0 }}>
                                    {index + 1}. {item.question}
                                </Typography>
                            }
                            secondary={
                                <Typography component="p" sx={{ ml: 2, fontSize: 15, lineHeight: '27px', p: 0 }}>
                                    {item.answer}
                                </Typography>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </Box>
    )
}
